// export const baseURL='http://localhost:1337'
export const baseURL='https://seal-app-5l5l8.ondigitalocean.app/'